import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import { memo } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { CircularProgress } from "@mui/material";
import SideBarComponent from "../../../components/store/layout/SideBarComponent";
import Translation from "../../../utils/Translation";

function SideBarStoreTop({
  isLoading,
  attributesAvailable,
  categoriesAvailable,
}) {
  const [state, setState] = React.useState({
    top: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box className="sidebar-top" role="presentation">
      <Box className="sidebar-close">
        <CloseIcon onClick={toggleDrawer(anchor, false)} fontSize="small" />
      </Box>

      {isLoading ? (
        <CircularProgress className="sidebar-preloader-position" />
      ) : (
        <SideBarComponent
          attributesAvailable={attributesAvailable}
          categoriesAvailable={categoriesAvailable}
        />
      )}
    </Box>
  );
  return (
    <Box>
      <React.Fragment key={"top"}>
        <Button variant="outlined" onClick={toggleDrawer("top", true)}>
          <Translation data="store.filter" />
        </Button>
        <Drawer anchor={"top"} open={state["top"]}>
          {list("top")}
        </Drawer>
      </React.Fragment>
    </Box>
  );
}

export default memo(SideBarStoreTop);
